import { Navigate } from "react-router-dom";
import { useLoginStore } from "../stores/useLoginStore";
import jwt_decode from "jwt-decode";
import MenuPrincipal from "../components/MenuPrincipal";

export default function RutaPrivada({ children, title, tipo = 'ADMIN' }) {

    document.title = title

    const { token } = useLoginStore(state=>state.objLogueado)

    if ( token === null ) {
        localStorage.removeItem('user')
        return <Navigate to="/login" />
    }

    var permiso;
    var decoded = jwt_decode(token)

    var date_actual = new Date().toString()
    var date_exp = new Date(decoded.exp * 1000).toString()

    permiso = ( date_actual < date_exp ) ? true : false
    if (!permiso) {
        localStorage.removeItem('user')
    }

    if ( tipo === 'ADMIN' ) {
        return permiso ? <MenuPrincipal componente={ children }/> : <Navigate to="/login" />
    } else {
        return permiso ? <MenuPrincipal componente={ children }/>: <Navigate to="/login" />
    }

    
}
